// eslint-disable-next-line spellcheck/spell-checker
export const FlagMalaysia = `${process.env.PUBLIC_URL}/flags/malaysia.svg`;
